import * as basicScroll from 'basicscroll';
export let mixinAnimation = {
    props: {
        isActive: Boolean
    },
    methods: {
        createScroll(from = 'top-top', to = 'bottom-bottom') {
            this.instance = basicScroll.create({
                elem: this.$refs.container,
                from,
                to,
                direct: true,
                props: {
                    playback: {
                        from: 0,
                        to: 1
                    }
                },
                inside: (instance, percentage, props) => {
                    instance;
                    percentage;
                    props;
                    if (!this.isControlScroll) {
                        const bh = this.$refs.animatedScroll.getBoundingClientRect().height;
                        const ch = this.$refs.container.getBoundingClientRect().height;
                        const sh = document.documentElement.clientHeight;
                        const blocksHeightRatio = ((ch - bh) / (ch - sh)) * 100;

                        this.innerBlockPosition = blocksHeightRatio > percentage ? 'fixed' : 'bottom';
                        this.blockPositioning();
                    }
                    if (!this.timeline) return;
                    this.timeline.pause();
                    this.timeline.progress(percentage / 100);
                },
                outside: (instance, percentage, props) => {
                    instance;
                    percentage;
                    props;
                    if (!this.isControlScroll) {
                        this.innerBlockPosition = percentage > 100 ? 'bottom' : 'top';
                        this.blockPositioning();
                    }
                    if (!this.timeline) return;
                    this.timeline.pause();
                    if (percentage < 0) {
                        this.timeline.progress(0.0001);
                    } else if (percentage > 100) {
                        this.timeline.progress(1);
                    }
                }
            });
            this.instance.start();
            this.isInited = true;
        },
        destroyAnimation() {
            if (this.instance) {
                this.instance.destroy();
                this.instance = null;
            }
            if (this.timeline) {
                this.timeline.kill();
                this.timeline = null;
            }
            this.isInited = false;
        },
        blockPositioning() {
            if (this.$refs.animatedScroll === undefined) {
                this.destroyAnimation();
                return;
            }
            if (this.innerBlockPosition === 'fixed') {
                this.$refs.animatedScroll.style.position = 'fixed';
                this.$refs.animatedScroll.style.top = '0';
                return;
            }
            if (this.innerBlockPosition === 'bottom') {
                this.$refs.animatedScroll.style.position = 'absolute';
                this.$refs.animatedScroll.style.bottom = '0';
                this.$refs.animatedScroll.style.top = 'auto';
                return;
            }
            if (this.innerBlockPosition === 'top') {
                this.$refs.animatedScroll.style.position = 'absolute';
                this.$refs.animatedScroll.style.top = '0';
                this.$refs.animatedScroll.style.bottom = 'auto';
                return;
            }
        },
        scrollHandler() {
            if (!this.$refs.container) {
                this.destroyAnimation();
                return;
            }

            let container = this.$refs.container.getBoundingClientRect(),
                animatedScroll = this.$refs.animatedScroll.getBoundingClientRect(),
                top = container.top,
                bottom = container.bottom,
                //clientHeight = document.documentElement.clientHeight,
                stateNew = top > 0 ? 'top' : bottom < animatedScroll.height ? 'bottom' : 'fixed',
                stateOld = this.innerBlockPosition ? this.innerBlockPosition : 'top';

            if (stateNew === stateOld) return;
            // if (stateNew) this.$refs.animatedScroll.classList.add(stateNew);
            // if (stateOld) this.$refs.animatedScroll.classList.remove(stateOld);
            this.innerBlockPosition = stateNew;
            this.blockPositioning();
        }
    },
    mounted() {
        if (this.isActive) {
            this.createAnimation();
            if (this.isControlScroll && !this._isScrollListener) {
                document.addEventListener('scroll', this.scrollHandler);
                this._isScrollListener = true;
            }
        }
    },
    updated() {
        if (this.isActive) {
            this.createAnimation();
            if (this.isControlScroll && !this._isScrollListener) {
                document.addEventListener('scroll', this.scrollHandler);
                this._isScrollListener = true;
            }
        }
    },
    beforeUpdate() {
        this.destroyAnimation();
        if (this.isControlScroll && this._isScrollListener) {
            document.removeEventListener('scroll', this.scrollHandler);
            this._isScrollListener = false;
        }
    },
    watch: {
        isActive() {
            if (this.isActive) {
                this.createAnimation();
                if (this.isControlScroll && !this._isScrollListener) {
                    document.addEventListener('scroll', this.scrollHandler);
                    this._isScrollListener = true;
                }
            } else {
                this.destroyAnimation();
                if (this.isControlScroll && this._isScrollListener) {
                    this._isScrollListener = false;
                    document.removeEventListener('scroll', this.scrollHandler);
                }
            }
        }
    }
};
